
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/leistungen/instandhaltung/instandhaltung-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="instandhaltung-view">
        <hero-section
            background-image="/images/hero/instandhaltung-hero.png"
            headline="Instandhaltung"
            subheadline="Instandhaltung mit FASE2"
            text="Wir als zuverlässiger Partner sorgen nicht nur für die Sauberkeit in Ihrer Immobilie, sondern tragen gleichzeitig zu deren Werterhaltung bei."
            button-text="Jetzt kostenlos beraten lassen!"
            button-link="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="uebersicht-instandhaltung">
                <h2 id="uebersicht-instandhaltung">Professionelle Instandhaltung für Ihre Immobilie</h2>
                <p>
                    Sauberkeit und Hygiene sind essenziell für ein angenehmes Wohn- und Arbeitsumfeld sowie den langfristigen Werterhalt Ihrer Immobilie. 
                    Mit unseren zuverlässigen instandhaltungs-Leistungen sorgen wir für makellose Treppenhäuser, saubere Fassaden und eine fachgerechte Müllentsorgung - gründlich, 
                    termingerecht und professionell.
                </p> 
            </article>

            <hex-text
                label="zustandsueberwachung"
                title="Zustandsüberwachung"
                image="/images/leistungen/instandhaltung/zustandspruefung.webp"
                left
            >
                <ul>
                    <li><strong>Regelmäßige Inspektionen:</strong> Geplante Überprüfungen der technischen Anlagen, Gebäudeinfrastruktur und Außenanlagen zur frühzeitigen Erkennung von Problemen.</li>
                    <li><strong>Fassaden- und Dachinspektionen:</strong> Überprüfung von Fassaden, Dächern und Fensterdichtungen auf Schäden oder Abnutzung, um mögliche Lecks oder Sicherheitsrisiken zu vermeiden.</li>
                    <li><strong>Feuchtigkeits- und Schimmelkontrolle:</strong> Monitoring von Feuchtigkeitswerten in Keller-, Dach- und Wohnräumen, um Schimmelbildung und Wasserschäden frühzeitig zu erkennen.</li>
                    <li><strong>Zähler- und Verbrauchskontrolle:</strong> Überprüfung von Zählern für Wasser, Strom und Gas, sowie die Analyse des Verbrauchs zur Identifikation von Unregelmäßigkeiten oder Einsparpotenzial.</li>
                    <li><strong>Zustandsprotokolle und Dokumentation:</strong> Erstellung von regelmäßigen Prüfberichten und Zustandsprotokollen zur transparenten Dokumentation und Planung von Wartungsmaßnahmen.</li>
                    <li><strong>Überwachung von Außenanlagen:</strong> Kontrolle von Gehwegen, Parkplätzen, Zufahrten und Grünflächen auf Abnutzung oder Schäden durch Witterungseinflüsse.</li>
                    <li><strong>Energieeffizienz-Checks:</strong> Überwachung und Analyse von Energieverbrauchsmustern, um Verbesserungspotenziale für eine nachhaltige Nutzung und Kostensenkung zu erkennen.</li>
                    <li><strong>Präventive Wartungsplanung:</strong> Planung und Durchführung von präventiven Wartungsmaßnahmen basierend auf den Überprüfungsergebnissen zur Vermeidung unerwarteter Ausfälle oder Reparaturen.</li>
                    <li><strong>Regelmäßige Fassadeninspektion:</strong> Überprüfung der Fassade auf mögliche Schäden oder Verschleiß, um frühzeitig Reparaturen oder Wartungsmaßnahmen einleiten zu können.</li>
                </ul>
            </hex-text>

            <hex-text
                label="fugenwartung"
                title="Fugenwartung"
                image="/images/leistungen/instandhaltung/fugenwartung.webp"
                right
            >
                <ul>
                    <li><strong>Reinigung von Fugen:</strong> Gründliche Entfernung von Schmutz, Staub, Algen und Moos aus Fugen zwischen Fliesen, Pflastersteinen und anderen Belägen.</li>
                    <li><strong>Fugenvergiftung und Versiegelung:</strong> Aufbringen von speziellen Fugenversiegelungen, um die Fugen vor Feuchtigkeit, Schimmel und Verschmutzung zu schützen und ihre Lebensdauer zu verlängern.</li>
                    <li><strong>Riss- und Fugenreparatur:</strong> Reparatur von beschädigten oder rissigen Fugen, um eine stabile und saubere Oberfläche zu gewährleisten.</li>
                    <li><strong>Vermeidung von Feuchtigkeits- und Schimmelbildung:</strong> Fugenbehandlung zur Reduzierung der Feuchtigkeitsaufnahme und der Gefahr von Schimmelbildung in Bad-, Küchen- und Außenbereichen.</li>
                    <li><strong>Auffrischung von Fugenfarben:</strong> Auffrischung und farbliche Anpassung von Fugenmörtel zur Wiederherstellung eines einheitlichen und sauberen Aussehens.</li>
                    <li><strong>Verwendung von speziellen Fugenreinigern:</strong> Einsatz von speziellen Reinigungsmitteln, die schonend, aber effektiv alle Ablagerungen und Verunreinigungen aus den Fugen entfernen.</li>
                    <li><strong>Langfristige Pflege und Wartung:</strong> Regelmäßige Wartung und Kontrolle der Fugen, um Abnutzung oder Schäden frühzeitig zu erkennen und entsprechend entgegenzuwirken.</li>
                    <li><strong>Behandlung von Außenfugen:</strong> Fugenpflege im Außenbereich, z. B. bei Pflaster- oder Terrassenflächen, um Witterungseinflüssen und Unkrautbewuchs vorzubeugen.</li>
                    <li><strong>Fugenpflege im Badezimmer und Küchenbereich:</strong> Besondere Pflege und Reinigung der Fugen in Feuchträumen wie Badezimmern und Küchen, um hygienische Bedingungen aufrechtzuerhalten.</li>
                    <li><strong>Fugenisolierung und -schutz:</strong> Zusätzliche Schutzmaßnahmen, wie das Abdichten von Fugen gegen Wasser und Schmutz, um Schäden an Belägen und Untergründen zu vermeiden.</li>
                </ul>
            </hex-text>

            <hex-text
                label="partnerbetriebe"
                title="Sanierungsunterstützung durch unsere Partnerbetriebe"
                image="/images/leistungen/instandhaltung/sanierungsunterstuetzung.webp"
                left
            >
                <ul>
                    <li><strong>Komplette Sanierungslösungen:</strong> Unterstützung bei der Planung, Durchführung und Koordination von Sanierungsprojekten, sowohl für Wohn- als auch Gewerbeimmobilien.</li>
                    <li><strong>Fachkundige Beratung:</strong> Individuelle Beratung zu Sanierungsmaßnahmen, von der Auswahl der richtigen Materialien bis hin zu baulichen Änderungen.</li>
                    <li><strong>Renovierungs- und Modernisierungsarbeiten:</strong> Durchführung von Renovierungen, Renovierungsarbeiten und Modernisierungen, um den Wert Ihrer Immobilie zu steigern.</li>
                    <li><strong>Fachgerechte Ausführung von Reparaturen:</strong> Reparatur und Wiederherstellung beschädigter Bauteile, z. B. Fassaden, Dach, Fenster, Böden und Leitungen.</li>
                    <li><strong>Feuchtigkeitssanierung:</strong> Beseitigung von Feuchtigkeitsproblemen, wie Schimmel oder Wasserschäden, durch spezialisierte Trocknungstechniken und Abdichtungsmaßnahmen.</li>
                    <li><strong>Energieeffizienzsteigerung:</strong> Durchführung von Maßnahmen zur Verbesserung der Energieeffizienz, wie z. B. Dämmung, Austausch von Heizsystemen oder Fenstern, um den Energieverbrauch zu senken.</li>
                    <li><strong>Brandschutzsanierungen:</strong> Verbesserung des Brandschutzes durch bauliche Änderungen und die Installation moderner Brandschutzsysteme.</li>
                    <li><strong>Koordination von Handwerksleistungen:</strong> Organisation und Überwachung der verschiedenen Handwerksleistungen, um einen reibungslosen Ablauf der Sanierung sicherzustellen.</li>
                    <li><strong>Projektmanagement:</strong> Übernahme des gesamten Projektmanagements von Sanierungsprojekten, einschließlich Budgetplanung, Zeitrahmen und Qualitätssicherung.</li>
                    <li><strong>Nachhaltige Sanierungsoptionen:</strong> Integration von nachhaltigen, umweltfreundlichen und kosteneffizienten Lösungen in die Sanierung, um langfristig den Wert und die Nachhaltigkeit der Immobilie zu erhöhen.</li>
                </ul>
            </hex-text>
        </div>
    </section>`,
      style: `instandhaltung-view .instandhaltung-view {
  margin: 0;
  padding: 0;
}
instandhaltung-view .instandhaltung-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
instandhaltung-view .instandhaltung-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
instandhaltung-view .instandhaltung-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  instandhaltung-view .instandhaltung-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  